var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchIntermediate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.96,10.15c-1.24,0-2.25-1.01-2.25-2.25s1.01-2.25,2.25-2.25s2.25,1.01,2.25,2.25S9.2,10.15,7.96,10.15z  M7.96,6.15c-0.96,0-1.75,0.79-1.75,1.75s0.79,1.75,1.75,1.75S9.71,8.87,9.71,7.9S8.92,6.15,7.96,6.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.46,6.49 9.02,6.25 11.79,1.16 14.12,2.32 13.9,2.76 12,1.82  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.68,6.47 4.07,1.85 2.18,2.82 1.95,2.37 4.27,1.18 7.12,6.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.7,14.84 8.94,9.75 9.38,9.51 11.91,14.18 13.82,13.23 14.04,13.68  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4.2,14.82 1.87,13.63 2.1,13.18 4,14.15 6.6,9.53 7.04,9.78  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIntermediate);
export default __webpack_public_path__ + "static/media/SwitchIntermediate.539f7a53a5b86b5148515dce226f8008.svg";
export { ForwardRef as ReactComponent };